// Definição para o modal de busca de Endereços do Próprio Parceiro
// Factory function - recebe o idParceiro como parâmetro para filtrar os endereços do parceiro atual

import { ST } from '@/constants/ST'

export const criarConfigBuscaEnderecoParceiro = (idParceiro) => ({
  label: 'Endereço',
  placeholder: 'ID ou Descrição...',
  titulo: 'Selecionar Endereço do Parceiro',
  endpointApi: `Parceiros/${idParceiro}/Enderecos`,
  idField: 'idParceiroEndereco',
  displayField: 'idParceiroEndereco',
  descField: 'descricaoEnderecoCompleto',
  camposFiltro: [
    { label: 'Descrição', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'Id', dataField: 'idParceiroEndereco', width: '7%' },
    { header: 'Descrição', dataField: 'descricao', width: '20%' },
    { header: 'País', dataField: 'pais', width: '15%' },
    { header: 'Logradouro', dataField: 'logradouro', width: '25%' },
    { header: 'Cidade', dataField: 'cidade', width: '15%' },
    { header: 'UF', dataField: 'uf', width: '8%' }
  ],
  filtrosFixos: {
    lstStatus: ST.Ativo
  }
})
